import {Checkbox} from "./Checkbox";
import {Section} from "./Section";
import {swapProductShippingStatus} from "../utils/texts";
import {OrderPaidProduct, TOrderDetail} from "../types/types";
import {useHistory} from "react-router-dom";
import {Table} from "./Table";
import {MProductCard} from "./MyPage/MProductCard";
import {Button} from "./Button";
import TrackingNumber from "./MyPage/TrackingNumber";
import { useUserState } from "../context/UserContext";
import React from "react";

type OrderDetailProductItemProps = {
    mobile?: boolean
    product: OrderPaidProduct
    order: TOrderDetail
    checked?: boolean
    onChecked?: () => void
    onConfirm?: () => void
    isRequestItem?: boolean
    isHistory?: boolean
    historyRequestOrderNumber?: string
    historyProductStatus?: string
}

const OrderDetailProductItem = (props: OrderDetailProductItemProps) => {
    const {mobile, order, product, checked, onChecked, onConfirm, isRequestItem = false, isHistory = false, historyRequestOrderNumber, historyProductStatus} = props;
    const history = useHistory();
    const {isLoggedIn} = useUserState();

    const findRequestOrderNumber = isHistory ? historyRequestOrderNumber : product.latestRequestOrderNumber!;

    const goToRequestDetail = () => {
        if (isLoggedIn) {
            history.push(`/mypage/refunds/${findRequestOrderNumber}`)
        } else (
            history.push(`/non-member/refunds/${findRequestOrderNumber}`)
        )
    }

    const productShippingStatus = order.status === 'CANCELED' ? '주문취소' : order.status === 'WAIT' ? '결제대기'
            : swapProductShippingStatus(product.productStatus, product.latestRequest, product.latestRequestStatus!)

    const isConfirmed = (product.productStatus === 'CONFIRMED') || (product.latestRequestStatus === 'COMPLETED')

    const canConfirm = (product.latestRequestStatus === 'DELIVERED') || (product.productStatus === 'DELIVERED' && product.latestRequestStatus === null) || product.latestRequestStatus === 'CANCELED'

    const isShowCheckbox = onChecked && product.productStatus !== 'CONFIRMED'

    if (mobile) {
        return (
            <div className="flex space-x-2 border-b pb-4 pt-2">
                {(isShowCheckbox) ? (
                    <Checkbox className="bg-white border border-gray-300"
                              checked={checked}
                              onChange={onChecked}
                    />
                ) : (
                    <div style={{width: 16}}/>
                )}
                <div className="w-20 h-28 relative rounded-md overflow-hidden">
                    <img src={product.thumbnailUrl}
                         alt=""
                         className="w-full h-full object-cover absolute"
                    />
                </div>

                <div className="flex-1 text-10">
                    <p className="font-bold text-brand-3 space-y-2">
                        <span className="text-brand-1">{product.productName}</span>
                        <br/>
                        <span>{product.color}</span>
                        <span> {product.unitPrice.toLocaleString()}원
                            /수량 {product.count}개 </span>
                        <span>
                            사이즈 : {product.sizeName}<br/>
                            적립금 적립 : {product.earnedMileage.toLocaleString()}원
                            <br/>총 결제금액 : {product.totalPrice.toLocaleString()}원
                        </span>
                        <br/>
                        {product.unavailableMileage && (
                            <span className="text-14 text-red-500" style={{fontSize:'5px'}}>
                                적립금 사용/적립 불가 상품
                            </span>
                        )}
                        <br/>
                        {product.unavailableCoupon && (
                            <span className="text-14 text-red-500" style={{fontSize:'5px'}}>
                                쿠폰 사용 불가 상품
                            </span>
                        )}
                    </p>
                </div>

                <Section className="flex flex-col justify-between">
                    {isRequestItem ? (
                        <button className="text-10 font-bold"
                                onClick={goToRequestDetail}
                        >
                            {historyProductStatus === 'CANCELED' ? '취소' : product.latestRequest === 'RETURN' ? '반품' : '교환'} {`>`}
                        </button>
                    ) : (
                        <div className="text-10 text-center">
                            <p className="font-bold">{productShippingStatus}</p>
                            {product.productStatus === 'CANCELED' && (
                                <p>취소사유: {product.cancelReason}</p>
                            )}
                            {!!product.latestRequest ? (
                                product.latestRequestShippingCompany && (
                                    <p className="">
                                        {product.latestRequestShippingCompany} <br/>
                                        <TrackingNumber shippingTrackingNumber={product.latestRequestShippingTrackingNumber!}/>
                                    </p>
                                ))
                            : (
                                <p className="">
                                    {product.shippingCompany} <br/>
                                    <TrackingNumber shippingTrackingNumber={product.shippingTrackingNumber!}/>
                                </p>
                            )}
                        </div>
                    )}

                    {onConfirm && (
                        <button className={`${(canConfirm || !isConfirmed) ? '' : 'text-gray-300'} bg-brand-2 text-10 px-4 py-2`}
                                disabled={!canConfirm || isConfirmed}
                                onClick={onConfirm}
                        >
                            구매 확정
                        </button>
                    )}

                </Section>
            </div>
        )
    } else {
        // desktop
        return (
            <Table.Row>
                <Table.Td>
                    {(isShowCheckbox) && (
                        <Checkbox className="bg-white border border-gray-300"
                                  checked={checked}
                                  onChange={onChecked}
                        />
                    )}
                </Table.Td>

                <Table.Td>
                    <MProductCard
                        thumbnail={product.thumbnailUrl}
                        name={product.productName}
                        color={product.color}
                        price={product.unitPrice.toLocaleString()}
                        quantity={product.count}
                        content={<p className="">사이즈 {product.sizeName}</p>}
                        unavailableMileage={product.unavailableMileage}
                        unavailableCoupon={product.unavailableCoupon}
                    />
                </Table.Td>
                <Table.Td>{product.sizeName}</Table.Td>
                <Table.Td>{product.earnedMileage.toLocaleString()}원</Table.Td>
                <Table.Td className="font-bold">
                    <div className="flex flex-col">
                        <span>{product.totalPrice.toLocaleString()}원</span>
                        {(order.appliedCoupons.length > 0 && product.couponDiscountPrice > 0) &&
                            <span>({order.appliedCoupons[0].name})</span>}
                    </div>
                </Table.Td>
                <Table.Td>
                    {isRequestItem ? (
                        <button className=""
                                onClick={goToRequestDetail}>
                            {historyProductStatus === 'CANCELED' ? '취소' : product.latestRequest === 'RETURN' ? '반품' : '교환'} {`>`}
                        </button>
                    ) : (
                        <div className="text-center">
                            <p className="font-bold text-gray-900">{productShippingStatus}</p>
                            {product.productStatus === 'CANCELED' && (
                                <p>취소사유: {product.cancelReason}</p>
                            )}
                            {!!product.latestRequest ? (
                                product.latestRequestShippingCompany && (
                                    <p className="">
                                        {product.latestRequestShippingCompany} <br/>
                                        <TrackingNumber shippingTrackingNumber={product.latestRequestShippingTrackingNumber!}/>
                                    </p>
                                ))
                            : (
                                <p className="">
                                    {product.shippingCompany} <br/>
                                    <TrackingNumber shippingTrackingNumber={product.shippingTrackingNumber!}/>
                                </p>
                            )}
                            {/*{product.productStatus === 'IN_RETURN' ? (*/}
                            {/*    product.latestRequestShippingCompany && (*/}
                            {/*        <p className="font-normal text-13">*/}
                            {/*            {product.latestRequestShippingCompany} <br/>*/}
                            {/*            <TrackingNumber shippingTrackingNumber={product.latestRequestShippingTrackingNumber!}/>*/}
                            {/*        </p>*/}
                            {/*    )*/}
                            {/*) : (*/}
                            {/*    <p className="font-normal text-13">*/}
                            {/*        {product.shippingCompany} <br/>*/}
                            {/*        <TrackingNumber shippingTrackingNumber={product.shippingTrackingNumber!}/>*/}
                            {/*    </p>*/}
                            {/*)}*/}
                        </div>
                    )}
                </Table.Td>
                <Table.Td>
                    {onConfirm && (
                        <Button onClick={onConfirm}
                                text="구매 확정"
                                className={`${(canConfirm || !isConfirmed) ? '' : 'text-gray-300'} bg-gray-100 text-13 px-3 h-10 font-normal`}
                                disabled={!canConfirm || isConfirmed}
                        />
                    )}
                </Table.Td>
            </Table.Row>
        )
    }
}

export default OrderDetailProductItem;
